import React, { useEffect, useState } from "react";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import emptyIllustration from "../../asessts/Images/empty_illustration.jpg";
import Loading from "../../components/loader/Loading";
import client from "../../services/Client";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Pagination from "../../components/common/Pagination";
function Lab() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState("");
  const [perPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = useSelector(
    (state) => state.currentPageSlice.currentPage
  );

  const fetchLab = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const response = await client.get(
        `/admin/healthFacility/get-laboratories?page=${page}`
      );
      console.log("lab", response);
      setPosts(response?.data?.data?.laboratoryRes);
      setTotal(response.data.data.total);
      setIsLoading(false);
    } catch (error) {
      console.log("Error while fetching posts", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLab(currentPage);
  }, [location]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(total / perPage)) {
      dispatch(setCurrentPage(newPage));

      const queryParams = new URLSearchParams(location.search);
      const activeTab = queryParams.get("tab") || "Hospital";

      navigate(`/facilities?page=${newPage}&tab=${activeTab}`);
    }
  };

  return (
    <div class="table-data-main">
      {isLoading ? (
        <Loading />
      ) : !posts || posts.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <img
            src={emptyIllustration}
            alt="No laboratories found"
            style={{ maxWidth: "400px", width: "100%", height: "auto" }}
          />
          <p style={{ marginTop: "20px", fontSize: "16px", color: "#666" }}>
            No data found
          </p>
        </div>
      ) : (
        <>
          <div class="table-data">
            <table border="0" cellpadding="0" style={{ width: "100%" }}>
              <thead
                style={{
                  backgroundColor: "#FDFDFD",
                  borderBottom: "1px solid #EDEDED",
                }}
              >
                <tr>
                  <th class="heading">Profile ID</th>
                  <th class="heading">Name</th>
                  <th class="heading">Email</th>
                  <th class="heading">Phone Number</th>
                  <th class="heading" style={{ width: "7%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {posts?.map((post, index) => (
                  <tr key={index} style={{ borderBottom: "1px solid #EDEDED" }}>
                    <td class="table-col">
                      <table>
                        <tr>
                          <td className="rating" style={{ border: "none" }}>
                            {post.profileId ? post.profileId : "--"}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="table-col">
                      {post.firstName} {post.lastName}
                    </td>
                    <td class="table-col">{post.email}</td>

                    <td class="table-col">
                      {post.phoneNumber
                        ? `+${post.phoneNumber.dialCode} ${post.phoneNumber.number}`
                        : "--"}
                    </td>
                    <td style={{ textAlign: "center" }} class="table-col">
                      <button class="action-btn">
                        {/* <img src={eyeIcon} alt="" /> */}
                        <Link
                          to={`/facilities-detail-Lab/${post.id}`}
                          onClick={() =>
                            console.log(
                              `Navigatingto22222: /facilities-detail-Lab/${post.id}`
                            )
                          }
                        >
                          {/* Fixed from _id to id */}
                          <img src={eyeIcon} alt="View details" />
                        </Link>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            total={total}
            perPage={perPage}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
}

export default Lab;
